// src/pages/Customer/WeeklyDietPlanPage.js

import React, { useState, useEffect } from 'react';
import { auth, db } from '../../firebase';
import { collection, query, orderBy, limit, getDocs } from 'firebase/firestore';
import '../../styles/WeeklyDietPlanPage.css'
// Import the reusable display component
import DietPlanSection from '../../components/DietPlanSection'; 

const WeeklyDietPlanPage = () => {
    const [dietPlanData, setDietPlanData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [currentUser, setCurrentUser] = useState(null);
    
    // Note: Removed the unused 'isMobile' state since it wasn't used in DietPlanSection

    useEffect(() => {
        const unsubscribeAuth = auth.onAuthStateChanged(async (user) => {
            if (!user) {
                setError('Please log in to view your diet plan.');
                setLoading(false);
                return;
            }
            
            setCurrentUser(user);
            setLoading(true);

            try {
                // Fetch the single latest diet plan for the current authenticated user
                const dietPlansCollectionRef = collection(db, 'users', user.uid, 'dietPlans');
                // Order by 'uploadedAt' (or 'lastModified', depending on your client-side implementation)
                const q = query(dietPlansCollectionRef, orderBy('uploadedAt', 'desc'), limit(1));
                const querySnapshot = await getDocs(q);

                if (!querySnapshot.empty) {
                    const planData = querySnapshot.docs[0].data();
                    setDietPlanData(planData);
                } else {
                    setError('No active diet plan found. Please contact your dietitian.');
                    setDietPlanData(null);
                }

            } catch (err) {
                console.error('Error fetching diet plan:', err);
                setError('Failed to load diet plan due to a network or server error.');
            } finally {
                setLoading(false);
            }
        });

        return () => unsubscribeAuth();
    }, []);

    if (loading) {
        return <div className="dashboard-container">Loading your weekly diet plan...</div>;
    }

    if (error) {
        return <div className="dashboard-container error-message">Error: {error}</div>;
    }
    
    // Use mealTimings from the fetched data, or provide a default for the 8 columns
    const mealTimings = dietPlanData?.mealTimings || Array(8).fill('').map((_, i) => `Meal ${i + 1}`);


    return (
        <div className="dashboard-container weekly-diet-page">
            <div className="dashboard-header">
                <h1>Full Weekly Diet Plan</h1>
                <p>View the current plan uploaded by your dietitian.</p>
            </div>

            {/* Render the plan using the imported component */}
            {dietPlanData ? (
                <DietPlanSection 
                    dietPlanData={dietPlanData} 
                    mealTimings={mealTimings} 
                />
            ) : (
                <p className="no-plan-message">No diet plan available right now.</p>
            )}
            
            
            
        </div>
    );
};

export default WeeklyDietPlanPage;